<template>
  <el-table
      :data="history"
      style="width: 100%;">
    <el-table-column
        width="130"
        prop="new_state"
        label="Current" />

    <el-table-column
        width="130"
        prop="old_state"
        label="Previous" />

    <el-table-column
        prop="agent"
        label="Agent" />

    <el-table-column
        prop="comment"
        label="Comment" />

    <el-table-column
        width="230"
        prop="created_at"
        label="Created At" />
  </el-table>
</template>

<script>
export default {
  name: "AccessoryHistory",
  props: {
    registries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    timeZone() {
      return this.$store.getters["ui/currentTimezone"];
    },
    history() {
      return this.registries.map((record) => {
        record.created_at = this.$moment
          .tz(self.created_at, this.timeZone)
          .format("MM/DD/YYYY - hh:mm A Z (z)");
        return record;
      });
    },
  },

  methods: {},
};
</script>

<style scoped></style>
